module.exports = __webpack_public_path__ + "static/pod-belong-1bb2f43bfb287da285b4186181e255c2.jpg";